var map = {
	"./Primate-House.jpg": 10,
	"./Primate-House2.jpg": 60,
	"./Primate-House3.jpg": 61,
	"./Primate-House4.jpg": 62,
	"./Primate-House5.jpg": 63,
	"./Primate-House6.jpg": 64,
	"./Primate-House7.jpg": 65,
	"./Primate-House8.jpg": 66,
	"./Primate-House9.jpg": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;